<template>
  <v-container v-show="viewPage" fluid>
    <div class="text-h2">
      Productos
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10">
        <v-card>
          <v-data-table :headers="headers" :items="students">
            <template v-slot:[`item.state`]="{ item }">
              <span
                :class="
                  item.state === 'Activo'
                    ? 'primary--text font-weight-bold'
                    : ''
                "
              >
                {{ item.state }}
              </span>
            </template>
            <template v-slot:[`item.license`]="{ item }">
              <invite-student :item="item" :invitation-type="invitationType" />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <help-button :tutorial="tutorial" />
  </v-container>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";
import HelpButton from "@/views/dashboard/pages/panel/HelpButton";
import InviteStudent from "@/views/dashboard/invitations/InviteStudent";

export default {
  components: {
    HelpButton,
    InviteStudent
  },
  data() {
    return {
      viewPage: false,
      invitationType: "byLicense",
      tutorial: "shop-my-products",
      uid: "",
      currentLicense: "",
      licenses: [],
      students: [],
      headers: [
        { text: "Tipo de Licencia", value: "product_name" },
        { text: "Usuario", value: "player_name" },
        { text: "Vencimiento", value: "end_date" },
        { text: "Estado", value: "state" },
        { text: "Acciones", value: "license" }
      ]
    };
  },
  computed: {
    ...mapState(["user"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const currentUser = firebase.auth().currentUser;
      this.uid = currentUser.uid;
      this.loadLicenses();
    },
    loadLicenses() {
      this.licenses = [];
      firebase
        .firestore()
        .collection("licenses")
        .where("uid", "==", this.uid)
        .get()
        .then(response => {
          var documents = response.docs;
          const licensesData = [];
          const toItems = [];
          documents.forEach(document => {
            this.licenses.push(document.id);
            licensesData.push(document.data());
          });

          for (let i = 0; i < licensesData.length; i++) {
            const data = licensesData[i];

            const currentDate = firebase.firestore.Timestamp.now().toDate();
            const playerName = data.player_name;
            var date;
            try {
              date = data.date.toDate();
            } catch {
              date = data.date;
            }
            const endDate = new Date(date);
            endDate.setMonth(endDate.getMonth() + 12);

            let state = "Disponible";
            if (currentDate > endDate) {
              state = "Caducado";
            } else if (playerName !== "") {
              state = "Activo";
            }

            const item = {
              product_name: data.product_name,
              player_name: playerName,
              end_date: endDate.toLocaleDateString(),
              state: state,
              license: this.licenses[i]
            };
            toItems.push(item);
          }
          this.currentLicense = this.licenses[0];
          this.students = toItems;
        })
        .catch(error => {
          console.log(error);
          alert(error);
        });
    },
    openLicenseModal(license) {
      this.currentLicense = license;
      this.$refs.studentInvitation.openModal("license");
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      const user = vm.user;
      if (user.type === "tutor" || user.type === "parent") {
        vm.viewPage = true;
        next();
      } else {
        console.log("Está intentando ingresar a una pagina no autorizada.");
        next({
          name: "Home"
        });
      }
    });
  }
};
</script>
